import { html, LpButton, LpFormField, LpSectionHeader } from '~/design-system';
export function renderPartnerEditFilters({ selects, }) {
    return String(html `
        <div class="partner-filters-backdrop" data-bind="visible: filtersModalVisible, click: onClickCancelFilters">
            <div class="partner-filters-dialog" data-bind="click: function () { return true; }, clickBubble: false">
                <div class="partner-filters-header">
                    <h3>Configure filters</h3>
                    ${LpButton({
        ariaLabel: 'Close',
        prefixIcon: 'x',
        size: 'sm',
        shape: 'square',
        variant: 'ghost',
        attributes: {
            'data-bind': 'click: onClickCancelFilters',
        },
    })}
                </div>
                <div class="partner-filters-layout">
                    <nav class="edit-nav edit-nav--rail" aria-label="Filter categories">
                        <!-- ko foreach: filterCategories -->
                        <button class="edit-nav__item" type="button" data-bind="click: $parent.onClickSelectFilterCategory, css: { 'is-active': $parent.activeFilterCategory() === id, 'has-values': $parent.filterCategoryCounts()[id] > 0 }">
                            <!-- ko if: icon -->
                            <i data-lp-component="Icon" data-icon-weight="regular" aria-hidden="true" data-bind="attr: { class: 'edit-nav__icon lp-icon ph ph-' + icon }"></i>
                            <!-- /ko -->
                            <span class="edit-nav__label" data-bind="text: label"></span>
                            <span class="edit-nav__count" data-bind="visible: $parent.filterCategoryCounts()[id] > 0, text: $parent.filterCategoryCounts()[id]"></span>
                        </button>
                        <!-- /ko -->
                    </nav>
                    <div class="partner-filters-panel">
                        <!-- ko with: activeFilterCategoryMeta -->
                        <div class="partner-filters-panel__header">
                            ${LpSectionHeader({
        title: html `<span data-bind="text: title"></span>`,
        description: html `<span data-bind="text: description"></span>`,
    })}
                        </div>
                        <!-- /ko -->
                        ${renderDemographicsSection(selects)}
                        ${renderGeographySection(selects)}
                        ${renderMilitarySection(selects)}
                        ${renderEducationSection(selects)}
                        ${renderFamiliesSection(selects)}
                    </div>
                </div>
                <div class="partner-filters-footer">
                    <span class="partner-filters-footer__count" data-bind="text: activeFilterCount() + (activeFilterCount() === 1 ? ' filter selected' : ' filters selected')"></span>
                    <div class="partner-filters-footer__actions">
                        ${LpButton({
        label: 'Cancel',
        variant: 'secondary',
        attributes: {
            'data-bind': 'click: onClickCancelFilters',
        },
    })}
                        ${LpButton({
        label: 'Apply filters',
        variant: 'primary',
        attributes: {
            'data-bind': 'click: onClickApplyFilters',
        },
    })}
                    </div>
                </div>
            </div>
        </div>
    `);
}
function renderDemographicsSection(selects) {
    return html `
        <div class="partner-filters-panel__section" data-bind="visible: activeFilterCategory() === 'demographics'">
            <div class="edit-grid">
                <div class="partner-filter-group edit-span">
                    ${LpSectionHeader({
        title: 'Age range',
        description: 'Set the minimum and maximum age allowed for this partner.',
        level: 3,
    })}
                    <div class="partner-filter-range">
                        ${LpFormField({
        label: 'Minimum age',
        children: html `
                                <input class="edit-input" min="0" max="99" type="number" placeholder="No minimum" data-bind="value: selectedMinAge" />
                            `,
    })}
                        ${LpFormField({
        label: 'Maximum age',
        children: html `
                                <input class="edit-input" min="0" max="99" type="number" placeholder="No maximum" data-bind="value: selectedMaxAge" />
                            `,
    })}
                    </div>
                </div>
                <div class="partner-filter-group edit-span">
                    ${LpSectionHeader({
        title: 'Education metrics',
        description: 'Limit leads by graduation year and minimum GPA.',
        level: 3,
    })}
                    <div class="partner-filter-group__grid">
                        ${LpFormField({
        label: 'High school class year (from)',
        children: html `
                                <input class="edit-input" type="number" placeholder="Earliest year" data-bind="value: selectedMinHsGradRange" />
                            `,
    })}
                        ${LpFormField({
        label: 'High school class year (to)',
        children: html `
                                <input class="edit-input" type="number" placeholder="Latest year" data-bind="value: selectedMaxHsGradRange" />
                            `,
    })}
                        ${LpFormField({
        label: 'Minimum GPA',
        children: html `
                                <input class="edit-input" max="5" min="0" step="0.1" type="number" placeholder="e.g. 2.5" data-bind="value: selectedMinGPA" />
                            `,
    })}
                    </div>
                </div>
                <div class="partner-filter-group edit-span">
                    ${LpSectionHeader({
        title: 'Identity',
        description: 'Filter leads by demographic attributes.',
        level: 3,
    })}
                    <div class="partner-filter-group__grid">
                        ${renderSelectFields([
        { label: 'Gender', children: selects.gender },
        { label: 'Ethnicity', children: selects.ethnicity },
    ])}
                    </div>
                </div>
            </div>
        </div>
    `;
}
function renderGeographySection(selects) {
    return html `
        <div class="partner-filters-panel__section" data-bind="visible: activeFilterCategory() === 'geography'">
            <div class="edit-grid">
                ${renderSelectFields([
        { label: 'Geographic subunits', children: selects.subunit },
        { label: 'Countries', children: selects.country },
        { label: 'US states', children: selects.usState },
    ])}
                ${LpFormField({
        label: 'ZIP / postal codes',
        className: 'edit-span',
        children: html `
                        <textarea class="edit-input edit-textarea" rows="4" placeholder="One code per line or comma-separated" data-bind="value: selectedZipCodes"></textarea>
                    `,
    })}
            </div>
        </div>
    `;
}
function renderMilitarySection(selects) {
    return html `
        <div class="partner-filters-panel__section" data-bind="visible: activeFilterCategory() === 'military'">
            <div class="edit-grid">
                ${renderSelectFields([
        { label: 'Branch of service', children: selects.service },
        { label: 'Service status', children: selects.militaryStatus },
        { label: 'Prior service', children: selects.servedBefore },
        { label: 'Pay grade', children: selects.paygrade },
    ])}
            </div>
        </div>
    `;
}
function renderEducationSection(selects) {
    return html `
        <div class="partner-filters-panel__section" data-bind="visible: activeFilterCategory() === 'education'">
            <div class="edit-grid">
                ${renderSelectFields([
        { label: 'Education level', children: selects.educationLevel },
        { label: 'Citizenship status', children: selects.citizenship },
    ])}
            </div>
        </div>
    `;
}
function renderFamiliesSection(selects) {
    return html `
        <div class="partner-filters-panel__section" data-bind="visible: activeFilterCategory() === 'families'">
            <div class="edit-grid">
                ${renderSelectFields([
        { label: 'Eligible families', className: 'edit-span', children: selects.family },
    ])}
            </div>
        </div>
    `;
}
function renderSelectFields(fields) {
    return html `
        ${fields.map((field) => LpFormField({
        label: field.label,
        className: field.className,
        children: field.children,
    }))}
    `;
}
